import { useState } from "react";
import { Link } from "react-router-dom";
import ContactBand from "../ContactBand";
import NewsRow from "../news/NewsRow";
import { useNewsItems } from "../news/useNewsItems";

const CATS = ["プレスリリース", "お知らせ"];

export default function NewsPage() {
  const { items } = useNewsItems();
  const [cat, setCat] = useState(null);
  const list = cat ? items.filter((i) => i.cat === cat) : items;

  return (
    <main>
      <section className="page-hero ground" data-en="NEWS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <span>お知らせ</span>
          </nav>
          <h1 className="page-title">
            お知らせ<strong>News</strong>
          </h1>
        </div>
      </section>
      <section className="section news news-page">
        <div className="container">
          <div className="filter-bar">
            <button
              type="button"
              className={cat === null ? "is-active" : undefined}
              aria-pressed={cat === null}
              onClick={() => setCat(null)}
            >
              すべて
            </button>
            {CATS.map((c) => (
              <button
                type="button"
                key={c}
                className={cat === c ? "is-active" : undefined}
                aria-pressed={cat === c}
                onClick={() => setCat(c)}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="row-list">
            {list.map((item) => (
              <NewsRow key={item.key} item={item} />
            ))}
          </div>
        </div>
      </section>
      <ContactBand />
    </main>
  );
}
